
<div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
    <div class="btn-toolbar mb-2 mb-md-0">
      <a routerLink="/users/create" class="btn btn-sm btn-outline-secondary">Add</a>
    </div>
  </div>


<!-- <div class="pb-2 pt-2 pl-4-">
<button  type="button" class="btn btn-info btn-rounded " data-toggle="modal" data-target="#add-contact">Add New Contact</button>
</div> -->

<div class="table-responsive">
  <table class="table table-lg">
    <thead>
      <tr>
        <th>#</th>
        <th>Name</th>
        <th>Email</th>
        <th>Role</th>
        <th>Action</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let user of users">
        <td>{{user.id}}</td>
        <td>{{user.first_name}} {{user.last_name}}</td>
        <td>{{user.email}}</td>
        <td>{{user.role.name}}</td>
        <td class="text-nowrap">
            <a href="javascript:void(0)" [routerLink]="['/users', user.id, 'edit']" class="btn  btn-outline-secondary mr-2"><i class="fa fa-pencil  m-r-3"></i></a>
            

          <a href="javascript:void(0)" (click)="delete(user.id)"  class="btn  btn-outline-danger" ><i class="fa fa-trash-o "></i></a>
            
        </td>
      </tr>
    </tbody>
  </table>
</div>
<div>

  
<app-paginator 
  [lastPage]="lastPage"
  (pageChanged)="refresh($event)"
></app-paginator>



   <!-- <div class="table-responsive">
              <table class="table table-bordered">
                  <thead>    
                      <tr>
                          <th>Task</th>
                          <th>Progress</th>
                          <th>Deadline</th>
                          <th class="text-nowrap">Action</th>
                      </tr>
                  </thead>
                  <tbody>
                      <tr>
                          <td>Lunar probe project</td>
                          <td>
                              <div class="progress progress-xs margin-vertical-10 ">
                                  <div class="progress-bar bg-danger" style="width: 35%; height:6px;"></div>
                              </div>
                          </td>
                          <td>May 15, 2015</td>
                          <td class="text-nowrap">
                              <a href="#" data-toggle="tooltip" data-original-title="Edit"> <i class="fa fa-pencil text-inverse m-r-10"></i> </a>
                              <a href="#" data-toggle="tooltip" data-original-title="Close"> <i class="fa fa-close text-danger"></i> </a>
                          </td>
                      </tr>
                      <tr>
                          <td>Dream successful plan</td>
                          <td>
                              <div class="progress progress-xs margin-vertical-10 ">
                                  <div class="progress-bar bg-warning" style="width: 50%; height:6px;"></div>
                              </div>
                          </td>
                          <td>July 1, 2015</td>
                          <td class="text-nowrap">
                              <a href="#" data-toggle="tooltip" data-original-title="Edit"> <i class="fa fa-pencil text-inverse m-r-10"></i> </a>
                              <a href="#" data-toggle="tooltip" data-original-title="Close"> <i class="fa fa-close text-danger"></i> </a>
                          </td>
                      </tr>
                      <tr>
                          <td>Office automatization</td>
                          <td>
                              <div class="progress progress-xs margin-vertical-10 ">
                                  <div class="progress-bar bg-success" style="width: 100%; height:6px;"></div>
                              </div>
                          </td>
                          <td>Apr 12, 2015</td>
                          <td class="text-nowrap">
                              <a href="#" data-toggle="tooltip" data-original-title="Edit"> <i class="fa fa-pencil text-inverse m-r-10"></i> </a>
                              <a href="#" data-toggle="tooltip" data-original-title="Close"> <i class="fa fa-close text-danger"></i> </a>
                          </td>
                      </tr>
                      <tr>
                          <td>The sun climbing plan</td>
                          <td>
                              <div class="progress progress-xs margin-vertical-10 ">
                                  <div class="progress-bar bg-primary" style="width: 70%; height:6px;"></div>
                              </div>
                          </td>
                          <td>Aug 9, 2015</td>
                          <td class="text-nowrap">
                              <a href="#" data-toggle="tooltip" data-original-title="Edit"> <i class="fa fa-pencil text-inverse m-r-10"></i> </a>
                              <a href="#" data-toggle="tooltip" data-original-title="Close"> <i class="fa fa-close text-danger"></i> </a>
                          </td>
                      </tr>
                      <tr>
                          <td>Open strategy</td>
                          <td>
                              <div class="progress progress-xs margin-vertical-10 ">
                                  <div class="progress-bar bg-info" style="width: 85%; height:6px;"></div>
                              </div>
                          </td>
                          <td>Apr 2, 2015</td>
                          <td class="text-nowrap">
                              <a href="#" data-toggle="tooltip" data-original-title="Edit"> <i class="fa fa-pencil text-inverse m-r-10"></i> </a>
                              <a href="#" data-toggle="tooltip" data-original-title="Close"> <i class="fa fa-close text-danger"></i> </a>
                          </td>
                      </tr>
                      <tr>
                          <td>Tantas earum numeris</td>
                          <td>
                              <div class="progress progress-xs margin-vertical-10 ">
                                  <div class="progress-bar bg-inverse" style="width: 50%; height:6px;"></div>
                              </div>
                          </td>
                          <td>July 11, 2015</td>
                          <td class="text-nowrap">
                              <a href="#" data-toggle="tooltip" data-original-title="Edit"> <i class="fa fa-pencil text-inverse m-r-10"></i> </a>
                              <a href="#" data-toggle="tooltip" data-original-title="Close"> <i class="fa fa-close text-danger"></i> </a>
                          </td>
                      </tr>
                  </tbody>
              </table>
          </div> -->
      
  